import { Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import type { Theme } from 'app/shopify';
import { useTheme } from '@shopify/restyle';
import type { ListingThumbnailPresentation } from './listing-thumbnail';

export function ListingThumbnailMedia({
  picture,
  presentation,
  size,
  useOwnCache,
}: {
  picture?: string | null;
  presentation: ListingThumbnailPresentation;
  size: number;
  useOwnCache: boolean;
}) {
  const theme = useTheme<Theme>();
  if (presentation.isDefaultRequestIcon) {
    return (
      <Row
        alignItems="center"
        style={{
          borderRadius: presentation.thumbnailBorderRadius,
          ...(presentation.isFillMode ? { width: '100%', aspectRatio: 1 } : { width: size, height: size }),
          backgroundColor: theme.colors['surface.brand.secondary-5.subtle'],
        }}
      >
        <Text
          lineHeight={presentation.fontSizeRequestIcon * 1.2}
          style={{ flexGrow: 1, textAlign: 'center', fontSize: presentation.fontSizeRequestIcon }}
        >
          {presentation.requestEmoji}
        </Text>
      </Row>
    );
  }

  return (
    <PCImage
      aspectRatio={1}
      cachePolicy="memory-disk"
      contentFit={presentation.contentFit}
      {...(presentation.isFillMode ? {} : { height: size })}
      recyclingKey={`${picture!}-thumbnail`}
      source={typeof presentation.pictureUrl === 'string' ? { uri: presentation.pictureUrl } : presentation.pictureUrl}
      style={{
        ...(presentation.isFillMode ? { width: '100%', height: '100%' } : {}),
        borderRadius: presentation.thumbnailBorderRadius,
        backgroundColor: presentation.imageBackgroundColor,
      }}
      useOwnCache={useOwnCache}
    />
  );
}
